import * as React from "react";
import { forwardRef } from "react";
const SvgOnDemand = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.95 16.75H21.75V3.75H2.25V16.75H8.1H12V20.25H7.6125H16.3875", stroke: "currentcolor", fill: "none", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgOnDemand);
export default ForwardRef;
